import React, {useState} from "react";
import CvStructure from "./CvStructure";

const CvProtocol = ({data}) => {

    const type = data?.type
    const structure = data?.cvStructure

    const cvs = data?.cvs
    const [value, setValue] = React.useState(20);

    React.useEffect(() => {
        const interval = window.setInterval(() => {
            setValue((current) => Math.min(100, Math.round(current + Math.random() * 25)));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return(
        <div style={{
            margin: "10px",
            width: "100%",
        }}>
            <div>
                {structure &&
                    <CvStructure data={structure} cvs={cvs}/>
                }
            </div>

            {!structure &&
            <div>
                loading ...
            </div>
            }

        </div>
    )
}

export default CvProtocol;
